import { render, staticRenderFns } from "./workroom.vue?vue&type=template&id=9dfbf4b4&"
import script from "./workroom.vue?vue&type=script&lang=js&"
export * from "./workroom.vue?vue&type=script&lang=js&"
import style0 from "./workroom.vue?vue&type=style&index=0&id=9dfbf4b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports